var map = {
	"./apple.jpg": "02c3",
	"./cat.jpeg": "c44a",
	"./dog.jpeg": "301a",
	"./egg.jpeg": "6afb",
	"./fish.jpeg": "a69f",
	"./football.jpg": "20a4",
	"./goat.jpeg": "c9bd",
	"./house.jpeg": "f26f",
	"./iron.jpeg": "94ac",
	"./jug.jpeg": "954b",
	"./kite.jpeg": "c4d6",
	"./lion.jpeg": "b547",
	"./mat.jpeg": "0ff4",
	"./nose.jpeg": "1a31",
	"./orange.jpeg": "8980",
	"./pencil.jpeg": "e78c",
	"./queen.jpeg": "80aa",
	"./rat.jpeg": "9163",
	"./ship.jpeg": "ffb7",
	"./table.png": "33b7",
	"./umbrella.jpeg": "b610",
	"./van.jpeg": "12cc",
	"./wheel.jpeg": "672e",
	"./xylophone.jpeg": "cb6e",
	"./yam.jpeg": "9c7c",
	"./zebra.jpeg": "c63d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b101";